import { decodeHTML } from "entities";
import * as mdurl from "mdurl";
import * as ucmicroModule from "uc.micro";

//#region rolldown:runtime
var __defProp = Object.defineProperty;
var __export = (all) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	return target;
};

//#endregion
//#region src/common/utils.ts
var utils_exports = /* @__PURE__ */ __export({
	arrayReplaceAt: () => arrayReplaceAt,
	assign: () => assign,
	countLines: () => countLines,
	escapeHtml: () => escapeHtml,
	escapeRE: () => escapeRE,
	fromCodePoint: () => fromCodePoint,
	has: () => has,
	isMdAsciiPunct: () => isMdAsciiPunct,
	isPunctChar: () => isPunctChar,
	isPunctCode: () => isPunctCode,
	isSpace: () => isSpace,
	isString: () => isString,
	isValidEntityCode: () => isValidEntityCode,
	isWhiteSpace: () => isWhiteSpace,
	lib: () => lib,
	mdurl: () => mdurl,
	normalizeReference: () => normalizeReference,
	ucmicro: () => ucmicro,
	unescapeAll: () => unescapeAll,
	unescapeMd: () => unescapeMd
});
const ucmicro = ucmicroModule;
function _class(obj) {
	return Object.prototype.toString.call(obj);
}
function isString(obj) {
	return _class(obj) === "[object String]";
}
const _hasOwnProperty = Object.prototype.hasOwnProperty;
function has(object, key) {
	return _hasOwnProperty.call(object, key);
}
function assign(obj, ...sources) {
	sources.forEach((source) => {
		if (!source) return;
		if (typeof source !== "object") throw new TypeError(`${String(source)}must be object`);
		Object.keys(source).forEach((key) => {
			obj[key] = source[key];
		});
	});
	return obj;
}
function isSpace(code) {
	return code === 9 || code === 32;
}
function isWhiteSpace(code) {
	if (code >= 8192 && code <= 8202) return true;
	switch (code) {
		case 9:
		case 10:
		case 11:
		case 12:
		case 13:
		case 32:
		case 160:
		case 5760:
		case 8239:
		case 8287:
		case 12288: return true;
	}
	return false;
}
function isPunctChar(ch) {
	return ucmicro.P.test(ch) || ucmicro.S.test(ch);
}
const PUNCT_CHAR_CACHE = /* @__PURE__ */ new Map();
function isPunctCode(ch) {
	if (isMdAsciiPunct(ch)) return true;
	const cached = PUNCT_CHAR_CACHE.get(ch);
	if (cached !== void 0) return cached;
	const value = isPunctChar(String.fromCharCode(ch));
	PUNCT_CHAR_CACHE.set(ch, value);
	return value;
}
function isMdAsciiPunct(ch) {
	switch (ch) {
		case 33:
		case 34:
		case 35:
		case 36:
		case 37:
		case 38:
		case 39:
		case 40:
		case 41:
		case 42:
		case 43:
		case 44:
		case 45:
		case 46:
		case 47:
		case 58:
		case 59:
		case 60:
		case 61:
		case 62:
		case 63:
		case 64:
		case 91:
		case 92:
		case 93:
		case 94:
		case 95:
		case 96:
		case 123:
		case 124:
		case 125:
		case 126: return true;
		default: return false;
	}
}
function normalizeReference(str) {
	str = str.trim().replace(/\s+/g, " ");
	if ("ẞ".toLowerCase() === "Ṿ") str = str.replace(/ẞ/g, "ß");
	return str.toLowerCase().toUpperCase();
}
function arrayReplaceAt(src, pos, newElements) {
	return [
		...src.slice(0, pos),
		...newElements,
		...src.slice(pos + 1)
	];
}
function isValidEntityCode(c) {
	if (c >= 55296 && c <= 57343) return false;
	if (c >= 64976 && c <= 65007) return false;
	if ((c & 65535) === 65535 || (c & 65535) === 65534) return false;
	if (c >= 0 && c <= 8) return false;
	if (c === 11) return false;
	if (c >= 14 && c <= 31) return false;
	if (c >= 127 && c <= 159) return false;
	if (c > 1114111) return false;
	return true;
}
function fromCodePoint(c) {
	if (c > 65535) {
		c -= 65536;
		const surrogate1 = 55296 + (c >> 10);
		const surrogate2 = 56320 + (c & 1023);
		return String.fromCharCode(surrogate1, surrogate2);
	}
	return String.fromCharCode(c);
}
const UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-\./:;<=>?@[\\\]^_`{|}~])/g;
const UNESCAPE_ALL_RE = new RegExp(`${UNESCAPE_MD_RE.source}|${/&([a-z#][a-z0-9]{1,31});/gi.source}`, "gi");
const DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function replaceEntityPattern(match, name) {
	if (name.charCodeAt(0) === 35 && DIGITAL_ENTITY_TEST_RE.test(name)) {
		const code = name[1].toLowerCase() === "x" ? Number.parseInt(name.slice(2), 16) : Number.parseInt(name.slice(1), 10);
		if (isValidEntityCode(code)) return fromCodePoint(code);
		return match;
	}
	const decoded = decodeHTML(match);
	if (decoded !== match) return decoded;
	return match;
}
function unescapeMd(str) {
	if (!str.includes("\\")) return str;
	return str.replace(UNESCAPE_MD_RE, "$1");
}
function unescapeAll(str) {
	if (!str.includes("\\") && !str.includes("&")) return str;
	return str.replace(UNESCAPE_ALL_RE, (match, escaped, entity) => {
		if (escaped) return escaped;
		return replaceEntityPattern(match, entity);
	});
}
const HTML_ESCAPE_TEST_RE = /[&<>"]/;
const HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const HTML_REPLACEMENTS = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;"
};
function replaceUnsafeChar(ch) {
	return HTML_REPLACEMENTS[ch];
}
function escapeHtml(str) {
	if (HTML_ESCAPE_TEST_RE.test(str)) return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
	return str;
}
const REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function escapeRE(str) {
	return str.replace(REGEXP_ESCAPE_RE, "\\$&");
}
const lib = {
	mdurl,
	ucmicro
};
function countLines(input) {
	if (input.length === 0) return 0;
	let count = 0;
	let pos = -1;
	while ((pos = input.indexOf("\n", pos + 1)) !== -1) count++;
	return count;
}

//#endregion
//#region src/parse/global_state.ts
const FOOTNOTE_DEF_RE = /(?:^|\n)[ \t]{0,3}\[\^[^\]\n]+\]:/m;
const ABBR_DEF_RE = /(?:^|\n)[ \t]{0,3}\*\[[^\]\n]+\]:/m;
const REFERENCE_DEF_RE = /(?:^|\n)[ \t]{0,3}\[(?!\^)(?:\\[\s\S]|[^\]\\[])+\][ \t]*:/m;
const GLOBAL_STATE_CHUNK_SCAN_WINDOW = 4096;
const GLOBAL_STATE_ENV_KEYS = [
	"references",
	"footnotes",
	"abbreviations",
	"abbr",
	"abbrs"
];
const GLOBAL_STATE_ENV_MARKER = Symbol.for("markdown-it-ts.global-state");
const hasOwn = Object.prototype.hasOwnProperty;
function isGlobalMarkdownStateReason(value) {
	return value === "reference-definition" || value === "footnote-definition" || value === "abbreviation-definition";
}
function isPlainObject(value) {
	if (!value || typeof value !== "object") return false;
	const proto = Object.getPrototypeOf(value);
	return proto === Object.prototype || proto === null;
}
function cloneSnapshotValue(value) {
	if (Array.isArray(value)) return value.map((item) => cloneSnapshotValue(item));
	if (isPlainObject(value)) {
		const out = {};
		for (const key of Object.keys(value)) out[key] = cloneSnapshotValue(value[key]);
		return out;
	}
	return value;
}
function ownKeys(value) {
	if (Array.isArray(value)) return value.map((_, index) => String(index));
	if (isPlainObject(value)) return Object.keys(value);
	return [];
}
function snapshotValueEquals(left, right) {
	if (Array.isArray(left) || Array.isArray(right)) {
		if (!Array.isArray(left) || !Array.isArray(right)) return false;
		if (left.length !== right.length) return false;
		for (let i = 0; i < left.length; i++) if (!snapshotValueEquals(left[i], right[i])) return false;
		return true;
	}
	if (isPlainObject(left) || isPlainObject(right)) {
		if (!isPlainObject(left) || !isPlainObject(right)) return false;
		const leftKeys = Object.keys(left);
		const rightKeys = Object.keys(right);
		if (leftKeys.length !== rightKeys.length) return false;
		for (const key of leftKeys) if (!hasOwn.call(right, key) || !snapshotValueEquals(left[key], right[key])) return false;
		return true;
	}
	return Object.is(left, right);
}
function getSnapshotKeyValue(value, key) {
	if (Array.isArray(value)) return value[Number(key)];
	if (isPlainObject(value)) return value[key];
}
function restoreSnapshotValue(target, snapshot) {
	if (Array.isArray(target) && Array.isArray(snapshot)) {
		target.length = snapshot.length;
		for (let i = 0; i < snapshot.length; i++) target[i] = cloneSnapshotValue(snapshot[i]);
		return target;
	}
	if (isPlainObject(target) && isPlainObject(snapshot)) {
		for (const key of Object.keys(target)) if (!hasOwn.call(snapshot, key)) delete target[key];
		for (const key of Object.keys(snapshot)) target[key] = cloneSnapshotValue(snapshot[key]);
		return target;
	}
	return cloneSnapshotValue(snapshot);
}
function resetOwnedSnapshotValue(env, key, entry) {
	const ownedKeys = entry.ownedKeys ?? [];
	const target = env[key];
	if (isPlainObject(target) || Array.isArray(target)) {
		const snapshotKeys = new Set(ownKeys(entry.value));
		for (const ownedKey of ownedKeys) if (entry.existed && snapshotKeys.has(ownedKey)) target[ownedKey] = cloneSnapshotValue(getSnapshotKeyValue(entry.value, ownedKey));
		else delete target[ownedKey];
		if (!entry.existed && ownKeys(target).length === 0) delete env[key];
		return;
	}
	if (entry.existed) env[key] = cloneSnapshotValue(entry.value);
	else delete env[key];
}
function getMarker(env) {
	const value = env[GLOBAL_STATE_ENV_MARKER];
	if (isGlobalMarkdownStateReason(value)) return {
		reason: value,
		snapshot: {}
	};
	if (value && typeof value === "object" && isGlobalMarkdownStateReason(value.reason) && value.snapshot && typeof value.snapshot === "object") return value;
	return null;
}
function setMarker(env, marker) {
	Object.defineProperty(env, GLOBAL_STATE_ENV_MARKER, {
		value: marker,
		enumerable: false,
		configurable: true,
		writable: true
	});
}
function detectGlobalMarkdownState(src) {
	if (!src) return null;
	if (FOOTNOTE_DEF_RE.test(src)) return "footnote-definition";
	if (ABBR_DEF_RE.test(src)) return "abbreviation-definition";
	if (REFERENCE_DEF_RE.test(src)) return "reference-definition";
	return null;
}
function detectGlobalMarkdownStateFromChunks(chunks) {
	let carry = "";
	for (const chunk of chunks) {
		if (!chunk) continue;
		const text = carry + chunk;
		const reason = detectGlobalMarkdownState(text);
		if (reason) return reason;
		carry = text.length > GLOBAL_STATE_CHUNK_SCAN_WINDOW ? text.slice(text.length - GLOBAL_STATE_CHUNK_SCAN_WINDOW) : text;
	}
	return detectGlobalMarkdownState(carry);
}
function getKnownGlobalMarkdownState(env) {
	return getMarker(env)?.reason ?? null;
}
function runWithKnownGlobalMarkdownState(env, reason, run) {
	if (getKnownGlobalMarkdownState(env)) resetKnownGlobalMarkdownState(env);
	if (!reason) return run();
	markKnownGlobalMarkdownState(env, reason);
	try {
		const result = run();
		finalizeKnownGlobalMarkdownState(env);
		return result;
	} catch (error) {
		resetKnownGlobalMarkdownState(env);
		throw error;
	}
}
function markKnownGlobalMarkdownState(env, reason) {
	try {
		resetKnownGlobalMarkdownState(env);
		const snapshot = {};
		for (const key of GLOBAL_STATE_ENV_KEYS) snapshot[key] = hasOwn.call(env, key) ? {
			existed: true,
			value: cloneSnapshotValue(env[key])
		} : { existed: false };
		setMarker(env, {
			reason,
			snapshot
		});
	} catch {}
}
function finalizeKnownGlobalMarkdownState(env) {
	const marker = getMarker(env);
	if (!marker) return;
	for (const key of GLOBAL_STATE_ENV_KEYS) {
		const entry = marker.snapshot[key];
		if (!entry) continue;
		entry.ownedKeys = [];
		const after = env[key];
		if (!isPlainObject(after) && !Array.isArray(after)) continue;
		const beforeKeys = new Set(ownKeys(entry.existed ? entry.value : void 0));
		entry.ownedKeys = ownKeys(after).filter((name) => {
			if (!beforeKeys.has(name)) return true;
			return !snapshotValueEquals(after[name], getSnapshotKeyValue(entry.value, name));
		});
	}
}
function resetKnownGlobalMarkdownState(env) {
	const marker = getMarker(env);
	if (!marker) return;
	for (const key of GLOBAL_STATE_ENV_KEYS) {
		const entry = marker.snapshot[key];
		if (!entry) {
			delete env[key];
			continue;
		}
		if (entry.ownedKeys) {
			resetOwnedSnapshotValue(env, key, entry);
			continue;
		}
		if (entry.existed) env[key] = restoreSnapshotValue(env[key], entry.value);
		else delete env[key];
	}
	delete env[GLOBAL_STATE_ENV_MARKER];
}

//#endregion
//#region src/parse/strategy_diagnostics.ts
const MDTS_DIAGNOSTICS = Symbol.for("markdown-it-ts.diagnostics");
function getDiagnosticsStore(env, create) {
	if (!env) return void 0;
	try {
		const existing = env[MDTS_DIAGNOSTICS];
		if (existing && typeof existing === "object") return existing;
		if (!create) return void 0;
		const diagnostics = {};
		Object.defineProperty(env, MDTS_DIAGNOSTICS, {
			value: diagnostics,
			enumerable: false,
			configurable: true,
			writable: true
		});
		return diagnostics;
	} catch {
		return;
	}
}
function getParseDiagnostics(env) {
	return getDiagnosticsStore(env, false);
}
function clearParseDiagnostics(env) {
	if (!env) return;
	try {
		delete env[MDTS_DIAGNOSTICS];
	} catch {}
}
function beginParseDiagnostics(env) {
	clearParseDiagnostics(env);
}
function setStrategyDiagnostics(env, info) {
	const diagnostics = getDiagnosticsStore(env, true);
	if (!diagnostics) return;
	diagnostics.strategy = info;
}
function setChunkDiagnostics(env, info) {
	const diagnostics = getDiagnosticsStore(env, true);
	if (!diagnostics) return;
	diagnostics.chunk = info;
}
function setUnboundedDiagnostics(env, info) {
	const diagnostics = getDiagnosticsStore(env, true);
	if (!diagnostics) return;
	diagnostics.unbounded = info;
}
function setEditableDiagnostics(env, info) {
	const diagnostics = getDiagnosticsStore(env, true);
	if (!diagnostics) return;
	diagnostics.editable = info;
}

//#endregion
export { normalizeReference as C, __export as E, isWhiteSpace as S, utils_exports as T, fromCodePoint as _, setChunkDiagnostics as a, isPunctCode as b, setUnboundedDiagnostics as c, finalizeKnownGlobalMarkdownState as d, getKnownGlobalMarkdownState as f, countLines as g, runWithKnownGlobalMarkdownState as h, getParseDiagnostics as i, detectGlobalMarkdownState as l, resetKnownGlobalMarkdownState as m, beginParseDiagnostics as n, setEditableDiagnostics as o, markKnownGlobalMarkdownState as p, clearParseDiagnostics as r, setStrategyDiagnostics as s, MDTS_DIAGNOSTICS as t, detectGlobalMarkdownStateFromChunks as u, isMdAsciiPunct as v, unescapeAll as w, isValidEntityCode as x, isPunctChar as y };